import React from 'react';
import Signup from '../Components/Signup/Signup';

export default function SignupPage() {
  return (
    <div>
      <Signup />
    </div>
  );
}
